import { Component } from '@angular/core';

@Component({
    selector : 'home',
    templateUrl : './root.component.html'
})
export class RootComponent {

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/root.component.ts